/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

interface BulletListProps {
    data: Record<string, string[]>;
}

interface NestedBulletListProps {
    data: Record<string, Record<string, string[]>>;
}

const MAP_KEY_TO_LABEL: any = {
    'deleted': 'Deleted merged data sets',
    'new': 'Added merged data sets',
    'modified': 'Modified merged data sets',
}

export const BulletList: React.FC<BulletListProps> = ({ data }) => {
    if (!data) return null;
    return (
        <ul>
            {Object.entries(data)
                .filter(([key, value]) => value.length > 0)
                .map(([key, value]) => (
                    <li key={key}>
                        {key}
                        <ul>
                            {value.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    </li>
                ))}
        </ul>
    );
};

/**
 * Renders a nested bullet list for regenerate merged datasets dialog in CovAppReq.
 */
export const NestedBulletList: React.FC<NestedBulletListProps> = ({ data }) => {
    if (!data) return null
    return (
        <ul>
            {Object.entries(data).map(([key, value]) => (
                <li key={key}>
                    {key}
                    <ul>
                        {Object.entries(value)
                            .filter(([subKey, subValue]) => subValue.length > 0)
                            .map(([subKey, subValue]) => (
                                <li key={subKey}>
                                    {MAP_KEY_TO_LABEL?.[subKey] ?? subKey}
                                    <ul>
                                        {subValue.map((item) => (
                                            <li key={item}>{item}</li>
                                        ))}
                                    </ul>
                                </li>
                            ))}
                    </ul>
                </li>
            ))}
        </ul>
    );
}